module.exports = __webpack_public_path__ + "7cf64a348fb0fe1bc7aee103833141ef.svg";